'use client';

import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import { ToastContainer } from '@/components/ui/toast-container';
import { ModalContainer } from '@/components/ui/modal-container';

export function NotificationProvider({ children }: { children: React.ReactNode }) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <>
      {children}
      {isMounted &&
        typeof window !== 'undefined' &&
        createPortal(
          <>
            <ToastContainer />
            <ModalContainer />
          </>,
          document.body
        )}
    </>
  );
}
